import React from 'react';
import { UsersManagementProvider } from './context/users-management-context';
import UsersManagement from './users-management';
import { BaseInternalFormFactory } from '../base-internal-form/base-internal-form-factory';

export const UsersManagementFactory: React.FC = () => {
    return (
        <BaseInternalFormFactory pageTitle="Gestão de Usuários">
            <UsersManagementProvider>
                <UsersManagement />
            </UsersManagementProvider>
        </BaseInternalFormFactory>
    );
};

export default UsersManagementFactory;
